var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticStyle:{"margin-bottom":"20px"}},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","margin-bottom":"15px"},attrs:{"size":"large"}},[_c('img',{attrs:{"src":require("@/assets/loading.gif"),"width":"300px"}})])
}]

export { render, staticRenderFns }